import { IOnboardingStep, TutorialId, OnboardingStepType } from './types';

// ============================================================
// Tutorial Inicial — exibido após o primeiro registro do usuário
// ============================================================
export const initialTutorialSteps: IOnboardingStep[] = [
  {
    id: 'welcome',
    type: OnboardingStepType.WELCOME,
    title: 'Bem-vindo à Fuzzy Makers',
    description:
      'Conheça nossa plataforma e descubra todas as possibilidades incríveis que você pode explorar aqui!',
    points: 500,
    order: 1,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'home-overview',
    type: OnboardingStepType.HOME,
    title: 'Explorando a Home',
    description:
      'Descubra as novidades da comunidade e confira o ranking dos professores. Prepare-se para se inspirar!',
    order: 2,
    completed: false,
    targetSelector: '.dashboard',
    padding: 0,
    position: 'top',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'activities-sidebar',
    type: OnboardingStepType.HOME,
    title: 'Menu de Atividades',
    description:
      'Explore a última trilha acessada e a última atividade realizada. Mantenha-se sempre em movimento!',
    order: 3,
    completed: false,
    targetSelector: '.activities-sidebar',
    position: 'left',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'left-sidebar',
    type: OnboardingStepType.HOME,
    title: 'Menu de navegação',
    description:
      'Acesse o menu de navegação e descubra ainda mais recursos e conteúdos incríveis esperando por você!',
    order: 4,
    completed: false,
    targetSelector: '.left-sidebar',
    position: 'right',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'complete-profile',
    type: OnboardingStepType.PROFILE,
    title: 'Complete seu Perfil',
    description:
      'Para ganhar mais pontos, atualize seu perfil! Você pode acessá-lo pela área de boas-vindas ou pelo menu superior à direita.',
    points: 500,
    order: 5,
    completed: false,
    targetSelector: '.welcome-section',
    position: 'bottom',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'initial-finish',
    type: OnboardingStepType.WELCOME,
    title: 'E muito mais!',
    description:
      'Explore todo o conteúdo que a Fuzzy Makers tem a oferecer! Em cada seção, clique no botão de ajuda (?) para iniciar o tutorial daquela área.',
    order: 6,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
];
// ============================================================
// Tutorial do Profile
// ============================================================
export const profileTutorialSteps: IOnboardingStep[] = [
  {
    id: 'profile-welcome',
    type: OnboardingStepType.PROFILE,
    title: 'Bem-vindo, Professor(a)!',
    description:
      'Preparado para explorar o seu perfil? Este é o seu espaço de mestre na plataforma! Vamos dar um passeio guiado pelas suas quatro abas exclusivas.',
    points: 500,
    order: 1,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'profile-personal-data',
    type: OnboardingStepType.PROFILE,
    title: 'Aba 1: Seus Dados Pessoais',
    description:
      'Aqui é o seu diário de classe pessoal! Edite suas informações e não se esqueça de manter sempre atualizados o seu número de celular e a escola onde você trabalha.',
    order: 2,
    completed: false,
    targetSelector: '#menu-personal-data',
    position: 'right',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'profile-achievements',
    type: OnboardingStepType.PROFILE,
    title: 'Aba 2: Suas Conquistas Épicas',
    description:
      'Acompanhe sua jornada gamificada! Veja em qual nível de experiência você está, exiba seus emblemas com orgulho e descubra o que falta para alcançar o seu próximo nível.',
    order: 3,
    completed: false,
    targetSelector: '#menu-achievements',
    position: 'right',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'profile-certificates',
    type: OnboardingStepType.PROFILE,
    title: 'Aba 3: Galeria de Certificados',
    description:
      'Todo o seu esforço e dedicação merecem ser celebrados! Nesta aba, você encontra e visualiza todos os seus certificados conquistados até aqui.',
    order: 4,
    completed: false,
    targetSelector: '#menu-certificates',
    position: 'right',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'profile-notifications',
    type: OnboardingStepType.PROFILE,
    title: 'Aba 4: Central de Notificações',
    description:
      'Ouviu o sinal bater? Na aba de Notificações você não perde nenhum recado! Fique de olho em todas as mensagens, alertas e novidades fresquinhas da plataforma.',
    points: 500,
    order: 5,
    completed: false,
    targetSelector: '#menu-notifications',
    position: 'right',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'profile-finish',
    type: OnboardingStepType.PROFILE,
    title: 'Tudo pronto para a aula!',
    description:
      'Agora você já domina cada canto do seu perfil! Explore, atualize seus dados e faça deste espaço a sua nova sala dos professores virtual. Uma excelente jornada para você!',
    order: 6,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
];

// ============================================================
// Tutorial da Home
// ============================================================
export const homeTutorialSteps: IOnboardingStep[] = [
  {
    id: 'home-welcome',
    type: OnboardingStepType.HOME,
    title: 'Bem-vindo à Home',
    description:
      'Aqui você encontra um resumo de suas atividades, novidades da comunidade e o ranking dos professores.',
    order: 1,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'home-dashboard',
    type: OnboardingStepType.HOME,
    title: 'Dashboard',
    description:
      'Confira as novidades da comunidade e o ranking dos professores. Prepare-se para se inspirar!',
    order: 2,
    completed: false,
    targetSelector: '.dashboard',
    padding: 0,
    position: 'top',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'home-activities',
    type: OnboardingStepType.HOME,
    title: 'Atividades Recentes',
    description:
      'Veja a última trilha acessada e a última atividade realizada. Continue de onde parou!',
    order: 3,
    completed: false,
    targetSelector: '.activities-sidebar',
    position: 'left',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'home-navigation',
    type: OnboardingStepType.HOME,
    title: 'Navegação',
    description:
      'Use o menu lateral para acessar todas as seções da plataforma: Vídeos, Ferramentas, Projetos, Comunidade e Desafios.',
    order: 4,
    completed: false,
    targetSelector: '.left-sidebar',
    position: 'right',
    requiredActions: ['.onboarding-continue-button'],
  },
];

// ============================================================
// Tutorial de Ferramentas (Hardwares)
// ============================================================
export const toolsTutorialSteps: IOnboardingStep[] = [
  {
    id: 'tools-welcome',
    type: OnboardingStepType.TOOLS,
    title: 'Bem-vindo às Ferramentas! 🛠️',
    description:
      'Prepare-se para transformar suas aulas! Aqui você encontra todo o nosso arsenal de hardwares e ferramentas incríveis para dar vida aos projetos dos seus alunos.',
    order: 1,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'tools-grid',
    type: OnboardingStepType.TOOLS,
    title: 'Seu Acervo de Ferramentas',
    description:
      'Cada card é um mundo de possibilidades! Ao clicar em uma ferramenta, você abre o perfil completo dela, mergulhando em detalhes, dicas e trilhas para aplicar na sala de aula.',
    order: 2,
    completed: false,
    targetSelector: '#hardware-grid',
    position: 'top',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'tools-filter',
    type: OnboardingStepType.TOOLS,
    title: 'Destrave Novos Conhecimentos 🔓',
    description:
      'Viu uma ferramenta bloqueada? É super simples resolver: ao clicar para destravar, você receberá um código secreto no seu e-mail. É só usá-lo para liberar o conteúdo e começar a criar!',
    order: 3,
    completed: false,
    targetSelector: '#unlock-hardware-button',
    position: 'left',
    requiredActions: ['.onboarding-continue-button'],
  },
];

// ============================================================
// Tutorial de Perfil de Ferramentas (Hardwares)
// ============================================================

export const toolsProfileTutorialSteps: IOnboardingStep[] = [
  {
    id: 'tool-profile-welcome',
    type: OnboardingStepType.TOOLS_PROFILE,
    title: 'Mergulhando na Ferramenta! 🤿',
    description:
      'Bem-vindo ao perfil desta ferramenta! Aqui é onde a mágica acontece. Vamos explorar como você pode dominar este recurso e levar inovações incríveis para a sala de aula.',
    order: 1,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'tool-progress',
    type: OnboardingStepType.TOOLS_PROFILE,
    title: 'Seu Progresso Maker 🚀',
    description:
      'Acompanhe de perto a sua evolução! Aqui você visualiza a sua taxa de progresso baseada nos tutoriais que já completou. Cada passo conta para você se tornar um mestre neste hardware!',
    order: 2,
    completed: false,
    targetSelector: '#progression-section',
    position: 'top',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'tool-skills-map',
    type: OnboardingStepType.TOOLS_PROFILE,
    title: 'Mapa de Habilidades 🗺️',
    description:
      'Quais superpoderes seus alunos vão desenvolver? O mapa de habilidades revela exatamente quais competências serão trabalhadas e aprimoradas ao utilizar esta ferramenta em seus projetos.',
    order: 3,
    completed: false,
    targetSelector: '#ability-map',
    position: 'bottom',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'tool-trails',
    type: OnboardingStepType.TOOLS,
    title: 'Trilhas de Aprendizagem 🛤️',
    description:
      'Pronto para a jornada? Nossas trilhas organizam todos os tutoriais e projetos passo a passo. É o seu roteiro perfeito para planejar aulas dinâmicas, guiando seus alunos do básico ao avançado.',
    order: 4,
    completed: false,
    targetSelector: '#learning-trails-section',
    position: 'top',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'tool-search',
    type: OnboardingStepType.TOOLS,
    title: 'Busca Rápida de Projetos 🔍',
    description:
      'Sabe exatamente o que quer criar ou quer fugir um pouco do roteiro? Use a nossa barra de pesquisa para encontrar projetos de forma independente, sem precisar navegar pelas trilhas.',
    order: 5,
    completed: false,
    targetSelector: '#tool-search-bar',
    position: 'bottom',
    requiredActions: ['.onboarding-continue-button'],
  },
];

// ============================================================
// Tutorial de Projetos
// ============================================================
export const projectsTutorialSteps: IOnboardingStep[] = [
  {
    id: 'projects-welcome',
    type: OnboardingStepType.TUTORIALS,
    title: 'Bem-vindo aos Projetos',
    description:
      'Aqui você encontra trilhas de aprendizado com atividades práticas para dominar cada ferramenta.',
    order: 1,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'projects-trails',
    type: OnboardingStepType.TUTORIALS,
    title: 'Trilhas de Aprendizado',
    description:
      'Cada trilha é composta por capítulos e atividades que ajudam você a aprender passo a passo.',
    order: 2,
    completed: false,
    targetSelector: '#projects-list',
    position: 'top',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'projects-progress',
    type: OnboardingStepType.TUTORIALS,
    title: 'Seu Progresso',
    description:
      'Acompanhe o andamento de cada trilha e não perca nenhuma atividade.',
    order: 3,
    completed: false,
    targetSelector: '#projects-progress',
    position: 'bottom',
    requiredActions: ['.onboarding-continue-button'],
  },
];

// ============================================================
// Tutorial de Atividades
// ============================================================
export const activitiesTutorialSteps: IOnboardingStep[] = [
  {
    id: 'activities-welcome',
    type: OnboardingStepType.TUTORIALS,
    title: 'Mão na Massa: Tutoriais! 🚀',
    description:
      'Bem-vindo à área de tutoriais! É aqui que a teoria vira prática. Vamos explorar como cada atividade está organizada para facilitar o seu planejamento e encantar seus alunos.',
    order: 1,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'tutorial-progress-stages',
    type: OnboardingStepType.TUTORIALS,
    title: 'Passo a Passo da Aula 📊',
    description:
      'No topo, junto ao título, fica a sua barra de progresso. A atividade é dividida em etapas incríveis para guiar a aula: Introdução, Montagem, Programação, Aprendendo o Código, Para Professor (exclusivo para você!) e Circuito.',
    order: 2,
    completed: false,
    targetSelector: '#tutorial-progress-header',
    position: 'bottom',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'tutorial-content-area',
    type: OnboardingStepType.TUTORIALS,
    title: 'Conteúdo Dinâmico 💡',
    description:
      'Logo abaixo fica o palco principal! Neste espaço, o conteúdo ganha vida e se adapta à sua aula, podendo ser um texto explicativo, uma apresentação visual interativa ou um tutorial completo de código.',
    order: 3,
    completed: false,
    targetSelector: '#tutorial-content-space',
    position: 'bottom',
    requiredActions: ['.onboarding-continue-button'],
  },
];

// ============================================================
// Tutorial de Vídeos
// ============================================================
export const videosTutorialSteps: IOnboardingStep[] = [
  {
    id: 'videos-welcome',
    type: OnboardingStepType.VIDEO,
    title: 'Bem-vindo aos Vídeos',
    description:
      'Aqui você encontra jornadas com playlists e vídeo-aulas sobre diferentes tecnologias e ferramentas.',
    order: 1,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'videos-journeys',
    type: OnboardingStepType.VIDEO,
    title: 'Jornadas',
    description:
      'Navegue pelas jornadas disponíveis. Cada jornada possui playlists organizadas por tema.',
    order: 2,
    completed: false,
    targetSelector: '#playlists-content',
    position: 'top',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'videos-tabs',
    type: OnboardingStepType.VIDEO,
    title: 'Categorias',
    description:
      'Use as abas para filtrar entre Progresso, Ferramentas, Conhecimentos e Trilhas.',
    order: 3,
    completed: false,
    targetSelector: '#lessons-list',
    position: 'top',
    requiredActions: ['.onboarding-continue-button'],
  },
];

// ============================================================
// Tutorial da Comunidade
// ============================================================
export const communityTutorialSteps: IOnboardingStep[] = [
  {
    id: 'community-welcome',
    type: OnboardingStepType.COMMUNITY,
    title: 'Bem-vindo à Comunidade',
    description:
      'Aqui você pode compartilhar experiências, fazer perguntas e interagir com outros professores.',
    order: 1,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'community-feed',
    type: OnboardingStepType.COMMUNITY,
    title: 'Feed de Publicações',
    description:
      'Confira as publicações da comunidade, curta e comente nos posts dos outros professores.',
    order: 2,
    completed: false,
    targetSelector: '#feed-community',
    position: 'top',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'community-create',
    type: OnboardingStepType.COMMUNITY,
    title: 'Criar Publicação',
    description:
      'Compartilhe suas experiências e projetos com a comunidade. Ganhe pontos ao interagir!',
    order: 3,
    completed: false,
    targetSelector: '#community-create-post',
    position: 'bottom',
    requiredActions: ['.onboarding-continue-button'],
  },
];

// ============================================================
// Tutorial de Desafios
// ============================================================
export const challengesTutorialSteps: IOnboardingStep[] = [
  {
    id: 'challenges-welcome',
    type: OnboardingStepType.CHALLENGES,
    title: 'Bem-vindo aos Desafios',
    description:
      'Aqui você encontra desafios para testar seus conhecimentos e habilidades. Ganhe pontos e suba no ranking!',
    order: 1,
    completed: false,
    position: 'center',
    targetSelector: '',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'challenges-list',
    type: OnboardingStepType.CHALLENGES,
    title: 'Lista de Desafios',
    description:
      'Explore os desafios disponíveis. Cada desafio oferece pontos que ajudam você a subir no ranking.',
    order: 2,
    completed: false,
    targetSelector: '.challenges-list',
    position: 'top',
    requiredActions: ['.onboarding-continue-button'],
  },
  {
    id: 'challenges-ranking',
    type: OnboardingStepType.CHALLENGES,
    title: 'Ranking',
    description:
      'Confira sua posição no ranking e compare com outros professores da plataforma.',
    order: 3,
    completed: false,
    targetSelector: '.challenges-ranking',
    position: 'bottom',
    requiredActions: ['.onboarding-continue-button'],
  },
];

// ============================================================
// Mapa de tutoriais por ID
// ============================================================
/**
 * Passos de cada tutorial.
 *
 * Parcial porque nem todo TutorialId tem tutorial escrito — TOURNAMENTS entrou
 * no enum antes de ganhar os seus. Declarar Record completo obrigava a
 * inventar passos com seletores que não existem na tela; quem lê o mapa já
 * trata a ausência (ver startTutorial, que sai cedo quando não há passos).
 */
export const tutorialStepsMap: Partial<Record<TutorialId, IOnboardingStep[]>> =
  {
    [TutorialId.INITIAL]: initialTutorialSteps,
    [TutorialId.PROFILE]: profileTutorialSteps,
    [TutorialId.HOME]: homeTutorialSteps,
    [TutorialId.TOOLS]: toolsTutorialSteps,
    [TutorialId.TOOLS_PROFILE]: toolsProfileTutorialSteps,
    [TutorialId.PROJECTS]: projectsTutorialSteps,
    [TutorialId.ACTIVITIES]: activitiesTutorialSteps,
    [TutorialId.VIDEOS]: videosTutorialSteps,
    [TutorialId.COMMUNITY]: communityTutorialSteps,
    [TutorialId.CHALLENGES]: challengesTutorialSteps,
  };

// Mensagens de boas-vindas por tutorial
/** Parcial pelo mesmo motivo do mapa de passos. */
export const tutorialWelcomeMessages: Partial<
  Record<TutorialId, { expression: string; description: string }>
> = {
  [TutorialId.INITIAL]: {
    expression: 'Bem-vindo!',
    description: 'Vamos começar o tour pela plataforma FuzzyMakers!',
  },
  [TutorialId.PROFILE]: {
    expression: 'Seu Perfil',
    description: 'Vamos explorar o seu QG na plataforma!',
  },
  [TutorialId.HOME]: {
    expression: 'Home',
    description: 'Vamos explorar a página inicial da plataforma!',
  },
  [TutorialId.TOOLS]: {
    expression: 'Ferramentas',
    description: 'Conheça as ferramentas e hardwares disponíveis!',
  },
  [TutorialId.TOOLS_PROFILE]: {
    expression: 'Perfil de Ferramentas',
    description: 'Explore o perfil detalhado de cada ferramenta e hardware!',
  },
  [TutorialId.PROJECTS]: {
    expression: 'Projetos',
    description: 'Descubra as trilhas de aprendizado e atividades!',
  },
  [TutorialId.ACTIVITIES]: {
    expression: 'Atividades',
    description: 'Aprenda a usar os tutoriais para planejar suas aulas!',
  },
  [TutorialId.VIDEOS]: {
    expression: 'Vídeos',
    description: 'Explore as jornadas e vídeo-aulas da plataforma!',
  },
  [TutorialId.COMMUNITY]: {
    expression: 'Comunidade',
    description: 'Interaja com outros professores na comunidade!',
  },
  [TutorialId.CHALLENGES]: {
    expression: 'Desafios',
    description: 'Teste seus conhecimentos e ganhe pontos!',
  },
};
